export default "__VITE_ASSET__Jqx1mo4t__"